export default __webpack_public_path__ + "b3ca27f.png";